import { useEffect, useState, useCallback } from "react";
import api from "../lib/api";
import { toast } from "sonner";

export default function DepartmentAssign({ entityType, entityId, label }) {
  const [depts, setDepts] = useState(null);
  const [links, setLinks] = useState([]);
  const load = useCallback(() => {
    if (!entityId) return;
    api.get(`/compliance/department-links?entity_type=${entityType}&entity_id=${entityId}`).then((r) => setLinks(r.data)).catch(() => {});
  }, [entityType, entityId]);
  useEffect(() => { api.get("/config/departments").then((r) => setDepts(r.data)).catch(() => setDepts([])); }, []);
  useEffect(() => { load(); }, [load]);

  const linkFor = (did) => links.find((l) => l.department_id === did);
  const toggle = async (did) => {
    const existing = linkFor(did);
    try {
      if (existing) { await api.delete(`/compliance/department-links/${existing.id}`); }
      else { await api.post("/compliance/department-links", { entity_type: entityType, entity_id: entityId, department_id: did }); }
      load();
    } catch (e) { toast.error("Failed to update department"); }
  };

  return (
    <div className="border border-slate-200 rounded-lg p-3" data-testid={`dept-assign-${entityType}`}>
      <div className="font-body font-semibold text-slate-800 text-sm">Departments {label ? <span className="text-slate-400 font-normal">— for {label}</span> : null}</div>
      <p className="text-slate-400 text-xs mb-2">{links.length === 0 ? "Floating — visible to everyone (no department restriction)." : "Only relevant to the selected departments."}</p>
      <div className="flex flex-wrap gap-1.5">
        {(depts || []).map((d) => {
          const on = !!linkFor(d.id);
          return (
            <button key={d.id} type="button" data-testid={`dept-toggle-${entityType}-${d.id}`} onClick={() => toggle(d.id)}
              className={`text-xs font-semibold px-2.5 py-1 rounded-full border-2 transition-colors duration-100 ${on ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-600 border-slate-300"}`}>
              {d.name}
            </button>
          );
        })}
        {depts === null && <span className="text-slate-400 text-xs">Loading…</span>}
        {depts !== null && depts.length === 0 && <span className="text-slate-400 text-xs">No departments yet — create them in Admin.</span>}
      </div>
    </div>
  );
}
